module.exports = __webpack_public_path__ + "static/media/questionNew.74f9b684.svg";